const semanticClassNames = {
  root: 'rich-text-box',
  input: 'rich-text-box__input',
  toolbar: 'rich-text-box__toolbar',
  icons: 'rich-text-box__icon',
} as const;

export default semanticClassNames;
